<template>
  <div class="flex-row forgeron-filter-container">
    <div v-show="searchBarVisible">
      <input
        :id="'search-' + name"
        v-model="localSubject"
        type="search"
        class="form-control border-0 rounded-0"
        :style="style"
        :placeholder="label"
        @keyup.enter.prevent="searchModels(route(`${routePrefix}.${resourceType}.search`))"
        style="appearance: none"
      />
    </div>
    <i
      v-show="searchBarVisible"
      class="fa-solid fa-circle-xmark"
      style="cursor: pointer; z-index: 1; line-height: 2rem; opacity: 0.25; position: relative"
      @click="toggleOrClear()"
    ></i>
    <i
      class="fa-solid fa-magnifying-glass p-2 me-2"
      style="cursor: pointer; z-index: 1"
      @click="toggleOrSearch(route(`${routePrefix}.${resourceType}.search`))"
    ></i>
  </div>
</template>

<script>
import { router } from '@inertiajs/vue3';
import { ref, computed } from 'vue';

export default {
  components: {},
  props: {
    subject: { type: String, default: null },
    name: { type: String, default: 'basic_search' },
    label: { type: String, default: () => 'Suchen...' },
    resourceType: { type: String, default: null },
    redirect: { type: String, default: null },
    style: { type: String, default: () => 'width: 10rem; height: 2.5rem;' },
  },
  setup(props) {
    const localSubject = ref(props.subject);
    const searchBarVisible = ref(!!props.subject);

    const toggleOrSearch = (url) => {
      if (!localSubject.value) {
        localSubject.value = '';
      }

      if (!searchBarVisible.value) {
        searchBarVisible.value = true;
        localSubject.value = props.subject;
      } else {
        if (subjectDidChange()) {
          handleSearch(url);
        }
        searchBarVisible.value = false;
      }
    };

    const subjectDidChange = () => {
      if (props.subject === null) {
        return localSubject.value.trim() !== '';
      }

      return localSubject.value.trim() !== props.subject.trim();
    };

    const toggleOrClear = () => {
      if (localSubject.value === '') {
        searchBarVisible.value = false;
      }
      localSubject.value = ''; // Clear the localSubject when manually clearing the input field
    };

    const handleSearch = (url) => {
      if (searchBarVisible.value) {
        searchModels(url);
        searchBarVisible.value = false; // Hide search bar after searching
        localSubject.value = ''; // Clearing the search field text
      }
    };

    const searchModels = (url) => {
      router.post(url, { search: localSubject.value });
    };

    return {
      localSubject,
      searchBarVisible,
      searchModels,
      toggleOrClear,
      toggleOrSearch,
      handleSearch,
    };
  },
};
</script>

<style>
input[type='search']::-webkit-search-cancel-button {
  display: none;
}
</style>
